import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import ScrollTipStore from '@src/business-components/scroll-tip/store';
import { getLocales } from '@src/global-locales/get-page-locales-data';

/**
 * ScrollTip
 * @param store {ScrollTipStore}
 * @returns {JSX.Element}
 * @constructor
 */
const ScrollTip = ({ store }) => {
  store.use();

  return (
    <div className={cx(styles.root, { [styles.showBtnBackTop]: store.isShowBackTop })}>
      <div className="scroll-tip-root">
        <div className="scroll-tip-group-1" data-name="底栏">
          <div className="scroll-tip-layer-1" data-name="框架" />
          <div className="scroll-tip-group-2" data-name="翻页提示">
            <div className="scroll-tip-layer-2" data-name="当前页数/总数">
              {String(store.currentPageNumber).padStart(2, '0')}/{String(store.currentPageSize).padStart(2, '0')}
            </div>
            <div className={styles.scrollTip}>
              <div className={cx('scroll-tip-group-3', styles.iconMouse)} data-name="滚动tips">
                <div className="scroll-tip-layer-3" data-name="鼠标滚动标识" />
                <div className="scroll-tip-layer-4" data-name="下滑提示箭头" />
              </div>
              <div className="scroll-tip-layer-5" data-name="SCROLL" />
            </div>
            <div className={cx(styles.btnBackTop)} data-name="返回顶部" onClick={store.backTop} />
          </div>

          {/* {store.showScrollTipCopyRight && (
            <div className="scroll-tip-group-4" data-name="版权信息" onClick={store.showCopyRight}>
              <div className="scroll-tip-layer-6" data-name="版权信息-边框" />
              <div className="scroll-tip-layer-7" data-name="版权信息" />
            </div>
          )} */}
          <div className="scroll-tip-group-4" data-name="版权信息" onClick={store.showCopyRight}>
            {getLocales('common_footer.copyright_btn')}
            <div className="scroll-tip-layer-6" data-name="版权信息-边框" />
          </div>

          {store.showPlayVideoBgBtn && (
            <div className="scroll-tip-group-5" data-name="播放键" onClick={store.controlKvVideo}>
              {store.playingKvVideo ? (
                <div className="scroll-tip-layer-8" data-name="暂停按钮-icon" />
              ) : (
                <div className="scroll-tip-layer-9" data-name="播放按钮-icon" />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(ScrollTip, ScrollTipStore);
